import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button, Alert } from 'antd';
import { StarOutlined } from '@ant-design/icons';
import { useParams, Link } from 'react-router-dom';
import { trackEvent } from '../../../controllers/TrackingController';

const UpgradeAlert = ({ updateFrom = '' }) => {
  const { networkId } = useParams();

  return (
    <Alert
      message={<FormattedMessage defaultMessage="Upgrade to have access to this feature" />}
      type="info"
      icon={<StarOutlined />}
      showIcon
      action={
        <Link
          to={`/networks/${networkId}/upgrade-plan`}
          onClick={() => {
            trackEvent({
              category: 'upgrade-paths',
              action: 'click',
              label: `update-from-${updateFrom}`,
            });
          }}
        >
          <Button type="primary" icon={<StarOutlined />} disabled={false}>
            <FormattedMessage defaultMessage="Upgrade" />
          </Button>
        </Link>
      }
    />
  );
};

UpgradeAlert.propTypes = {
  updateFrom: PropTypes.string,
};

export default UpgradeAlert;
